<div class="container">
  <p class="title">{{ title }}</p>
  <div class="sub-titles">
    <p class="externalId" *ngIf="externalId">
      {{ externalId }}
    </p>
    <p class="clientName" *ngIf="clientName">
      {{ clientName }}
    </p>
  </div>
</div>
